import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4 bg-background-50">
          <h1 className="text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none">
            404
          </h1>
          <div className="relative z-10 -mt-20">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-error-warning-line text-3xl text-primary-500"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-2">
              页面未找到
            </h2>
            <p className="text-sm text-foreground-600 mb-1 font-mono">{location.pathname}</p>
            <p className="text-sm text-foreground-500 mb-8">
              您访问的页面不存在或已被移除
            </p>
            <div className="flex items-center justify-center gap-3">
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-home-4-line"></i>
                返回首页
              </Link>
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
                返回上页
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}